module.exports = __webpack_public_path__ + "img/Brief Overview.83ea540f.svg";